const videoIdPattern = /^[A-Za-z0-9_-]{11}$/;

export function youtubeEmbedUrl(input) {
  try {
    const url = new URL(input);
    const isYouTube = ["www.youtube.com", "youtube.com", "youtu.be"].includes(url.hostname);
    if (!isYouTube) {
      return null;
    }
    const videoId = url.hostname === "youtu.be"
      ? url.pathname.split("/").filter(Boolean)[0]
      : url.searchParams.get("v") || url.pathname.split("/")[2];
    if (!videoIdPattern.test(videoId || "")) {
      return null;
    }
    return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
  } catch {
    return null;
  }
}